/* eslint-disable */
import DOMPurify from 'isomorphic-dompurify'

export const getBySlug = (content, slug) => {
  if (!content || !Array.isArray(content) || content.length === 0) {
    return {}
  }

  return content.find(item => item?.slug === slug)
}

export const getById = (content, slug) => {
  if (!content || !Array.isArray(content) || content.length === 0) {
    return {}
  }

  return content.find(item => item?.id === slug)
}

export const getByTitle = (content, title) => {
  if (!content || !Array.isArray(content) || content.length === 0) {
    return {}
  }

  return content.find(item => item?.title === title)
}

export const getImgByTitle = (page, title) => {
  if (!page || !Array.isArray(page?.images) || page?.images?.length === 0) {
    return {}
  }

  return page?.images?.find(image => image?.title === title)
}

export const getShortTextFromPage = (page, slug) => {
  return getBySlug(page?.shortTextFields, slug)?.value || ''
}

export const getLongTextFromPage = (page, slug) => {
  return getBySlug(page?.longTextFields, slug)?.value || ''
}

// Cookie content helper function - only keep the one that has special logic
export const getCookieBodyContent = (cookieData, isMobile) => {
  if (isMobile && cookieData?.mobileBody) {
    return cookieData.mobileBody
  }
  return cookieData?.body || ''
}

// Generic getter for direct properties
export const getProperty = (obj, property, defaultValue = '') => {
  return obj?.[property] || defaultValue
}

// Extract text content from HTML string and convert links to markdown format
export const extractTextFromHTML = (htmlString) => {
  if (!htmlString) return ''
  
  // First, sanitize HTML to remove dangerous tags and attributes
  const sanitizedHtml = DOMPurify.sanitize(htmlString, {
    ALLOWED_TAGS: ['a', 'b', 'strong'], // Only allow tags we handle explicitly
    ALLOWED_ATTR: ['href'],
    RETURN_DOM: false,
    RETURN_DOM_FRAGMENT: false
  });

  // Apply replacements repeatedly until no more changes occur
  let text = sanitizedHtml
  let previousText
  
  // Extract links and convert to markdown format
  do {
    previousText = text
    text = text.replace(/<a[^>]*href="([^"]*)"[^>]*>([^<]*)<\/a>/gi, '[$2]($1)')
  } while (text !== previousText)
  
  // Remove bold/strong tags around links
  do {
    previousText = text
    text = text.replace(/<(strong|b)>\s*\[([^\]]+)\]\(([^)]+)\)\s*<\/(strong|b)>/gi, '[$2]($3)')
  } while (text !== previousText)
  
  // Remove all remaining HTML tags - apply repeatedly
  do {
    previousText = text
    text = text.replace(/<[^>]*>/g, '')
  } while (text !== previousText)
  
  // Decode HTML entities safely using DOMPurify
  // For SSR compatibility, check if document exists
  if (typeof document !== 'undefined') {
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = DOMPurify.sanitize(text, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
      KEEP_CONTENT: true
    })
    text = tempDiv.textContent || tempDiv.innerText || ''
  } else {
    // Fallback for SSR - decode common entities
    text = text
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
  }
  
  // Clean up escaped backslashes in markdown
  text = text.replace(/\\\*/g, '*')
  
  // Clean up extra whitespace
  text = text.trim()
  
  return text
}